import React from 'react'
import type { TextProps } from '@vtex/admin-ui'
import { Text, csx } from '@vtex/admin-ui'

export type BadgeProps = TextProps & {
  variant?: 'info' | 'positive'
}

// TODO: promote to ui/components?
export const Badge = ({ variant, children }: BadgeProps) => (
  <Text
    variant="detail"
    className={csx({
      alignItems: 'center',
      background: variant === 'info' ? '$blue10' : '$green10',
      color: variant === 'info' ? 'black !important' : '#285F2B !important',
      paddingX: '$space-3',
      paddingY: '$space-1',
      borderRadius: '24px',
    })}
  >
    {children}
  </Text>
)
